'use strict';

function CnAutosaverController(clockService, $timeout) {
  var vm = this;
  var AUTOSAVE_SECONDS = 30;
  var AUTOSAVE_SECONDS_CHECK = 10;
  var changes_saved = false;

  vm.$onInit = $onInit;
  vm.$onChanges = $onChanges;

  function $onInit() {
    vm.showIcon = false;
    vm.onSave = vm.onSave();
    clockService.setIntervalFunction(autosave, AUTOSAVE_SECONDS_CHECK);
  }

  function $onChanges(changes) {
    if (isManualChange(changes.formFields)) {
      clockService.restart();
      changes_saved = false;
    }
  }

  function isManualChange(fields) {
    var prev = fields.previousValue;
    var curr = fields.currentValue;
    if (!angular.isArray(prev) || curr.length !== prev.length) {
      return false;
    }
    for (var i = 0; i < curr.length; i++) {
      if (angular.isDefined(curr[i]) && prev[i] !== curr[i]) {
        return true;
      }
    }
    return false;
  }

  function autosave() {
    if (!changes_saved && clockService.getSecondsPassed() >= AUTOSAVE_SECONDS) {
      changes_saved = true;
      clockService.reset();
      vm.onSave().then(function () {
        vm.showIcon = true;
        $timeout(function () { vm.showIcon = false; }, 3000);
      });
    }
  }
}

module.exports = CnAutosaverController;



/*****************
 ** WEBPACK FOOTER
 ** ./src/app/app/components/cn-autosaver/cn-autosaver.controller.js
 ** module id = 136
 ** module chunks = 0
 **/